module.exports = __webpack_public_path__ + "img/40_69_007_140.a08eeaa3.jpg";